import $ from 'jquery'
import 'slick-carousel'
import { createApp } from 'vue'

const CLASS_NAME_TEIKIBIN_REVIEW = 'js-teikibin-review'
const QUERY_CAROUSEL = '#review-carousel'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinReview = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_REVIEW
  )
  if (!elementsTeikibinReview.length) return

  Array.from(elementsTeikibinReview).forEach((element) => {
    createApp({
      name: 'SectionsTeikibinReview',
      mounted() {
        const elementArrowPrev = this.$refs.elementArrowPrev
        const elementArrowNext = this.$refs.elementArrowNext
        $(QUERY_CAROUSEL).slick({
          centerMode: true,
          centerPadding: '60px',
          prevArrow: elementArrowPrev,
          nextArrow: elementArrowNext,
          responsive: [
            {
              breakpoint: 500,
              settings: {
                centerPadding: '40px',
              },
            },
          ],
        })
      },
    }).mount(element)
  })
})
